var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGiants = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 65 79",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.828 1.172a4 4 0 0 0-5.656 0L18.858 12.485a4 4 0 0 0 0 5.657l7.921 7.922L1.172 51.672A4 4 0 0 0 0 54.5v20a4 4 0 0 0 8 0V56.157l24.5-24.5 24.5 24.5V74.5a4 4 0 0 0 8 0v-20a4 4 0 0 0-1.172-2.828L38.721 26.564l8.421-8.422a4 4 0 0 0 0-5.657L35.828 1.172Zm-8.485 14.142L33 9.657l5.657 5.657L33 20.97l-5.657-5.657Z",
  fill: "#EB544D"
})));

export default SvgGiants;